
import dayjs from 'dayjs'
import moment from 'moment'
import Api from '../config/api'
export default{
  getUrlKey:function(name){
    return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
  },
  formatDate:function (date) {
    return dayjs(date).format('YYYY年MM月DD日');
  },
  formatDateType:function (date,type) {
    if (!date) return '';
    return moment(new Date(date)).format(type);
  },
  compareDate:function (date) {
    let now = new Date();
    return now.getTime() > date;
  },
  completUrl : url => {
    if (!url) return '';
    const isCompletion = url.includes('https://') || url.includes('http://');
    if (isCompletion) return url;
    return Api.VUE_APP_IMG_HOST + (url.startsWith('/') ? url : '/' + url);
  },
  /**
 * 完善阿里云图片url并剪裁图片
 * @param {String} url
 * @param {Number} width
 * @param {Number} height
 */
 clip : (url, width, height) => {
  if (url && url.indexOf('blob:') !== -1) return url;
  if (!url) return '';
  let newUrl =  (url.includes('https://') || url.includes('http://'))? url : (Api.VUE_APP_IMG_HOST + (url.startsWith('/') ? url : '/' + url));

  if (height || width) {
    newUrl += newUrl.includes('?') ? '&' : '?';
  }

  if (height && width) {
    if (newUrl.includes('x-oss-process=image/resize,m_fill')) {
      newUrl = newUrl.split('?')[0] + '?x-oss-process=image/resize,m_fill,w_' + width + ',h_' + height;
    } else {
      newUrl += 'x-oss-process=image/resize,m_fill,w_' + width + ',h_' + height;
    }
  } else if (height) {
    newUrl += 'x-oss-process=image/resize,m_fill,h_' + height;
  } else if (width) {
    newUrl += 'x-oss-process=image/resize,m_fill,w_' + width;
  }

  return newUrl;
},

/**
 * 压缩图片，不改变图片尺寸比例
 * @param {String} url
 * @param {Number} quality 压缩比例
 */
 compress : (url, quality) => {
  if (!url) return '';
  const newUrl = (url.includes('https://') || url.includes('http://'))? url : (Api.VUE_APP_IMG_HOST + (url.startsWith('/') ? url : '/' + url));

  return newUrl + (newUrl.includes('?') ? '&' : '?') + 'x-oss-process=image/quality,q_' + (quality || 100);
}

}



// WEBPACK FOOTER //
// ./src/plugin/utils.js